module.exports = __webpack_public_path__ + "assets/media/conley-2.ec504fcb.png";